import { useDataSubmit } from 'Simple/Data.js'

export function useOnClick(props) {
  let submit = useDataSubmit({
    viewPath: props.viewPath,
    context: 'selected_connection',
  })

  return async function onClick() {
    submit({
      id: null,
      skip_connection_check: true,
    })
  }
}
